import { lazy } from "react";
import Home from "./pages/Home";

import { branchRoutes } from "./endpoints/branches";
import { adminRoutes } from "./endpoints/admin";
import { productsRoutes } from "./endpoints/products";
import { servicesRoutes } from "./endpoints/services";
import { customersRoutes } from "./endpoints/customers";
import { invoicesRoutes } from "./endpoints/invoices";
import { usersRoutes } from "./endpoints/users";
import { ordersRoutes } from "./endpoints/orders";
import { articlesRoutes } from "./endpoints/articles";

const Onboarding = lazy(() => import("./pages/admin/Onboarding"));
const WaitingTime = lazy(() => import("./pages/WaitingTime"));
const FetchAppointments = lazy(
  () => import("./pages/appointments/FetchAppointments")
);

export const appRoutes = [
  {
    path: "/home",
    component: Home,
  },
  {
    path: "/appointments",
    component: FetchAppointments,
  },
  {
    path: "/waiting-time",
    component: WaitingTime,
  },
  {
    path: "/onboarding/:id",
    component: Onboarding,
  },
  ...adminRoutes,
  ...productsRoutes,
  ...branchRoutes,
  ...servicesRoutes,
  ...customersRoutes,
  ...invoicesRoutes,
  ...usersRoutes,
  ...ordersRoutes,
  ...articlesRoutes,
];
